import { map, first, takeUntil } from 'rxjs/operators';
import { CartStorageService } from './../../../core/services/cart-storage.service';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DigitalService } from '../../../core/services/digital.service';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { Message } from '../../../core/class/message';
import { Common } from '../../../core/constants/common';

// Thành/Tỉnh
interface cityComboBox {
  id: number;
  name: string;
}

// Quận/Huyện
interface districtsComboBox {
  id: number;
  cityId: number;
  name: string;
  description: string
}

//Xã/phường
interface wardsCombobox {
  id: number;
  districtId: number;
  name: string;
  description: string
}

//Gói
interface ListPackage {
  packageId: string; // Id gói cước
  packageCode: String; // Mã gói cước
  packageName: string; // Tên gói cước
  quantity: number; // Tổng số lượng gói cước - Sum(listPackage.quantity)
  price: number; // Đơn giá gói cước (maxlength = 9 kí tự)
  duration: number; // Thời hạn gói cước (maxlength = 9 kí tự)
  amount: number; // Tổng tiền hàng - Sum(listPackage.amount)
}

//Model Save
interface ModelSaveOrder {
  transactionId: string; // Mã giao dịch thanh toán qua cổng thanh toán online -- Nếu thanh toán COD thì giá trị này null
  customerName: string; // Họ tên khách hàng 
  phone: string; // Số điện thoại
  email: string; // Email khách hàng
  provinceId: number; // Id Tỉnh/ Thành phố
  provinceName: string;  // Tên Tỉnh
  districtId: number; // Id Quận/ Huyện 
  districtName: string; // Tên Huyện
  wardId: number;  // Id Phường/ Xã
  wardName: string;  // Tên xã
  deliveryAddress: string; // Địa chỉ nhận hàng (maxlength = 255 kí tự)
  installType: number; // Hình thức lắp đặt: (0: Viettel lắp ) (1: Tự lắp đặt mặc định 1 với ViettelCA)
  installPrice: number; // Chi phí lắp đặt (maxlength = 9 kí tự) -- Set: null
  paymentMethod: number; //Phương thức thanh toán (1: COD) (2: VTPAY) (3: BANKPLUS) (4: VISA) (5: ATM) (6: OTHER)
  paymentTypeStr: string;
  feeShipping: number; // Phí vận chuyển  (maxlength = 9 kí tự)
  note: string; // Ghi chú (maxlength = 255 kí tự)
  total: number; // Tổng chi phí đơn hàng (maxlength = 9 kí tự)
  invoice: number; // Xuất hóa đơn hay không: (1: Có) (0: Không) (Nếu giá trị bằng 1 sẽ validate bắt buộc nhập các trường: taxCode, companyName, companyAddress)
  taxCode: string; // Mã số thuế
  companyName: string;  // Tên công ty
  companyAddress: string; // Địa chỉ công ty
  quantity: number; // Số lượng
  amount: number; // Tổng tiền của từng gói sản phẩm
  discount: number; // Giảm giá
  vat: number; // Thuế 
  orderDate: string;  // Ngày đặt hàng
  type: number;
  otp: number;
  orderCode: string;
  id: number;
  listPackage: ListPackage[];  //Gói
}

@Component({
  selector: 'app-order-now',
  templateUrl: './order-now.component.html',
  styleUrls: ['./order-now.component.scss']
})
export class OrderNowComponent implements OnInit, AfterViewInit {
  listPackageOrderNow: any[] = [];
  totalPackage: number = 0; //tổng số Gói
  totalMoneyCOD: number = 0; //tổng tiền COD
  totalMoneyViettelPay: number = 0; //tổng tiền ViettelPay
  modelSaveOrder: ModelSaveOrder;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  addresses: any[] = [
    {
      cityId: null,
      districtId: null,
      wardId: null,
      address: ''
    }
  ]

  cities: cityComboBox[] = [];
  cityFilterCtrl: FormControl = new FormControl();
  public filteredCity: ReplaySubject<cityComboBox[]> = new ReplaySubject<cityComboBox[]>(1);

  districts: districtsComboBox[] = [];
  districtsFilterCtrl: FormControl = new FormControl();
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);


  wards: wardsCombobox[] = [];
  wardFilterCtrl: FormControl = new FormControl();
  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);

  private _onDestroy = new Subject<void>();

  isShowInvoice: boolean = false;
  allComplete: any;
  typePayment: number = 1; //Default 1: CODE OTP ; 2: ViettelPay

  isNextInforCustomer: boolean = false;
  isShowTextBackToBuyCart: boolean = false;
  @ViewChild('focusFirstElement', { static: false }) focusFirstElement: ElementRef<any>;
  isLinear: boolean = true;
  firstFormGroup: boolean = false;
  secondFormGroup: boolean = false;
  isNextScreenConfirm: boolean = false;

  constructor(
    private cartStorageService: CartStorageService,
    private digitalService: DigitalService,
    private router: Router,
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private message: Message,
    private _formBuilder: FormBuilder
  ) {

    this.modelSaveOrder = {
      transactionId: "",
      customerName: "",
      phone: "",
      email: "",
      provinceId: null,
      provinceName: "",
      districtId: null,
      districtName: "",
      wardId: null,
      wardName: "",
      deliveryAddress: "",
      installType: 0,
      installPrice: 0,
      paymentMethod: null,
      paymentTypeStr: "",
      feeShipping: 0,
      note: "",
      total: 0,
      invoice: 0,
      taxCode: "",
      companyName: "",
      companyAddress: "",
      quantity: 0,
      amount: 0,
      discount: 0,
      vat: 0,
      orderDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy hh:mm:ss'),
      type: 0,
      otp: 0,
      orderCode: "",
      id: 0,
      listPackage: []
    }

    const arrayListOrder = this.cartStorageService.getListInCart();
    if (arrayListOrder == null || arrayListOrder == undefined || arrayListOrder.length <= 0) {
      this.router.navigate(['']);
    } else {
      return;
    }
  }

  ngOnInit() {
    // this.firstFormGroup = this._formBuilder.group({
    //   firstCtrl: ['', Validators.required]
    // });
    // this.secondFormGroup = this._formBuilder.group({
    //   secondCtrl: ['', Validators.required]
    // });

    this.loadOrderList();
    this.loadCities();

    //reload city, districts, ward
    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.digitalService.filterCertificateType(this.cities, this.cityFilterCtrl, this.filteredCity);
      });

    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.digitalService.filterCertificateType(this.districts, this.districtsFilterCtrl, this.filteredDistricts);
      });

    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.digitalService.filterCertificateType(this.wards, this.wardFilterCtrl, this.filteredWard);
      });
  }

  ngAfterViewInit() {
    //this.focusFirstElement.nativeElement.focus();
  }

  //Begin----------------------------------***THÔNG TIN ĐƠN HÀNG***----------------------------------//
  //input handle minus and plus
  changeQuantity(quantity, packageId) {
    this.listPackageOrderNow.forEach(x => {
      if (x.packageId === packageId) {
        x.quantityOrder = quantity < 0 ? 0 : quantity > 100 ? 100 : quantity;
        x.servicePriceToQuantityCOD = (Number(x.servicePrice) * x.quantityOrder).toString();
        x.servicePriceToQuantityViettelPay = Math.round(x.servicePriceVT * x.quantityOrder) + '';
      }
      return x;
    });

    this.totalPackage = 0;
    this.listPackageOrderNow.forEach(x => {
      this.totalPackage = this.totalPackage + x.quantityOrder;
    });
    if (this.totalPackage === 0) {
      this.isNextInforCustomer = false;
    }
    else {
      this.isNextInforCustomer = true;
    }

    this.totalMoneyOrder(this.listPackageOrderNow);

  }

  //get list order for local storage
  loadOrderList() {
    const arrayListOrder = this.cartStorageService.getListInCart();
    this.totalPackage = 0;
    this.totalMoneyCOD = 0;
    this.totalMoneyViettelPay = 0;
    if (arrayListOrder.length > 0 && arrayListOrder !== null) {
      arrayListOrder.forEach(x => {
        const percentAfterDiscount = 100 - Number(x.column4);
        if (percentAfterDiscount !== null && percentAfterDiscount !== undefined) {
          x.servicePriceVT = Math.round(((x.servicePrice * percentAfterDiscount) / 100)) + '';
          x.servicePriceToQuantityViettelPay = Math.round(x.servicePriceVT * x.quantityOrder) + '';
        }
        return x;
      });
      this.totalMoneyOrder(arrayListOrder);
    }

    //lưu vào local storage.
    this.cartStorageService.saveLocalStorage(arrayListOrder);
    this.listPackageOrderNow = this.cartStorageService.getListInCart();
    this.modelSaveOrder.listPackage = this.listPackageOrderNow;

    if (this.listPackageOrderNow.length <= 0) {
      this.isNextInforCustomer = false;
      this.isShowTextBackToBuyCart = false;
    } else {
      this.isNextInforCustomer = true;
      this.isShowTextBackToBuyCart = true;
    }
  }

  deleteItemOrder(item: any) {
    const index: number = this.listPackageOrderNow.indexOf(item);
    if (index !== -1) {
      this.listPackageOrderNow.splice(index, 1);
    }
    else {
      return;
    }

    if (this.listPackageOrderNow.length <= 0) {
      this.isNextInforCustomer = false;
      this.isShowTextBackToBuyCart = false;
    } else {
      this.isNextInforCustomer = true;
      this.isShowTextBackToBuyCart = true;
    }

    this.totalMoneyCOD = 0;
    this.totalMoneyViettelPay = 0;
    if (this.listPackageOrderNow.length > 0) {
      this.listPackageOrderNow.forEach(x => {
        const percentAfterDiscount = 100 - Number(x.column4);
        if (percentAfterDiscount !== null && percentAfterDiscount !== undefined) {
          x.servicePriceVT = Math.round(((x.servicePrice * percentAfterDiscount) / 100)) + '';
          x.servicePriceToQuantityViettelPay = Math.round(x.servicePriceVT * x.quantityOrder) + '';
          this.totalMoneyCOD = Number(this.totalMoneyCOD) + Number(x.servicePriceToQuantityCOD);
          this.totalMoneyViettelPay = Number(this.totalMoneyViettelPay) + Number(x.servicePriceToQuantityViettelPay);
        }
        return x;
      });
    }
    this.totalMoneyOrder(this.listPackageOrderNow);

    //lưu vào local storage.
    this.cartStorageService.saveLocalStorage(this.listPackageOrderNow);

  }

  totalMoneyOrder(listPackageOrderNow) {
    this.totalPackage = 0;
    this.totalMoneyCOD = 0;
    this.totalMoneyViettelPay = 0;
    listPackageOrderNow.forEach(x => {
      this.totalPackage = this.totalPackage + x.quantityOrder;
      this.totalMoneyCOD = Number(this.totalMoneyCOD) + Number(x.servicePriceToQuantityCOD);
      this.totalMoneyViettelPay = Number(this.totalMoneyViettelPay) + Number(x.servicePriceToQuantityViettelPay);
    });
  }

  backToBuyPakage() {
    this.router.navigate([""]);
  }

  //----------------------------------***THÔNG TIN ĐƠN HÀNG***----------------------------------End//




  //Begin----------------------------------***THÔNG TIN KHÁCH HÀNG***----------------------------------//

  loadCities() {
    if (localStorage.getItem('cities_digital') == null && localStorage.getItem('cities_digital') == undefined) {
      this.digitalService.getAllCity().subscribe(rs => {
        const response = JSON.parse(rs);
        this.cities = response.data == undefined || response.data == null ? '' : response.data.data;
      localStorage.setItem('cities_digital', JSON.stringify(this.cities));
        this.filteredCity.next(this.cities.slice());
      }, (error) => {
        console.log(error);
        //this.toastr.error(this.message.getMessage('messages.cannot_get_city_list'));
      });
    } else {
      this.cities = JSON.parse(localStorage.getItem('cities_digital'));
      this.filteredCity.next(this.cities.slice());
    }
  }

  loadDistricts(value: any) {
    if (localStorage.getItem('districts_digital') === null) {
      this.digitalService.getAllDistricts(value).subscribe(rs => {
        const response = JSON.parse(rs);
        if (response != null && response != undefined) {
          this.districts = response.data == undefined || response.data == null ? '' : response.data.data;
          localStorage.setItem('districts_digital', JSON.stringify(this.districts));
          this.filteredDistricts.next(this.districts.slice());
        }
      }, (error) => {
        console.log(error);
        //this.toastr.error(this.message.getMessage('messages.cannot_get_district_list'));
      });
    } else {
      this.districts = JSON.parse(localStorage.getItem('districts_digital'));
      this.filteredDistricts.next(this.districts.slice());
    }
  }

  loadWards(value: any) {
    if (localStorage.getItem('wards_digital') === null) {
      this.digitalService.getAllWard(value).subscribe(rs => {
        const response = JSON.parse(rs);
        if (response != null && response != undefined) {
          this.wards = response.data == undefined || response.data == null ? '' : response.data.data;
          localStorage.setItem('wards_digital', JSON.stringify(this.wards));
          this.filteredWard.next(this.wards.slice());
        }
      }, (error) => {
        console.log(error);
        //this.toastr.error(this.message.getMessage('messages.cannot_get_ward_list'));
      });
    } else {
      this.wards = JSON.parse(localStorage.getItem('wards_digital'));
      this.filteredWard.next(this.wards.slice());
    }
  }


  onChange(value: number, opt: number = 0) {
    localStorage.removeItem('cities_digital');
    switch (opt) {
      case 0:
        localStorage.removeItem('districts_digital');
        localStorage.removeItem('wards_digital');
        this.loadDistricts(value);
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 1:
        localStorage.removeItem('wards_digital');
        this.loadWards(value);
        break;
      default:
        break;
    }
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  goForward(isNext: any, stepper: MatStepper) {
    if (isNext) {
      stepper.next();
    } else {
      return;
    }
  }

  //----------------------------------***THÔNG TIN KHÁCH HÀNG***----------------------------------End//

  //xuất Hóa đơn
  showInvoice() {
    this.isShowInvoice = !this.isShowInvoice;
  }

  //Begin----------------------------------***THÔNG TIN THANH TOÁN***----------------------------------//
  saveCustomerInformation() {
    const isFindNameCity = this.cities.filter(x => x.id == this.modelSaveOrder.provinceId);
    if (isFindNameCity.length > 0 && isFindNameCity !== null) {
      this.modelSaveOrder.provinceName = isFindNameCity[0].name;
    }

    const isFindNameDistrict = this.districts.filter(x => x.id == this.modelSaveOrder.districtId);
    if (isFindNameDistrict.length > 0 && isFindNameDistrict !== null) {
      this.modelSaveOrder.districtName = isFindNameDistrict[0].name;
    }

    const isFindNameWard = this.wards.filter(x => x.id == this.modelSaveOrder.wardId);
    if (isFindNameWard.length > 0 && isFindNameDistrict !== null) {
      this.modelSaveOrder.wardName = isFindNameWard[0].name;
    }

    this.modelSaveOrder.listPackage = this.listPackageOrderNow;
    localStorage.setItem('modelSaveOrder', JSON.stringify(this.modelSaveOrder));
  }

  navigateToConfirm() {
    if (this.modelSaveOrder.listPackage.length <= 0 || this.modelSaveOrder.listPackage === null || this.modelSaveOrder.listPackage === undefined) {
      this.toastr.warning("Không xác nhận được thông tin thanh toán. Vui lòng kiểm tra lại phần Thông tin đơn hàng, Thông tin khách hàng");
      this.isNextScreenConfirm = false;
    }
    else {
      this.isNextScreenConfirm = true;
    }

    if (this.isNextScreenConfirm) {
      this.goToItems();
    } else {
      return;
    }

  }

  goToItems() {
    localStorage.setItem('typePayment', JSON.stringify(this.typePayment));
    this.router.navigate(['/digital/confirm-order'], {
      queryParams: {
        typePayment: this.typePayment,
      }
    });
  }
  //----------------------------------***THÔNG TIN THANH TOÁN***----------------------------------End//

}
